import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Тут больше ничего нет ")

import { computed, watch } from "vue";
import { groupBy } from "lodash";

import { useAsync } from "@/use/useAsync";
import { useOperations } from "@/use/useOperations";
import { useStore } from "@/use/useStore";
import { IOperation } from "@/types/operation";
import { formatCurrency, formatDate } from "@/utils";

import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";

import OperationCell from "@/components/operations/OperationCell.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OperationsList',
  setup(__props) {

const { currentUser } = useStore();
const { operations, fetchOperations } = useOperations();

const fetchData = useAsync(() => fetchOperations({ limit: "100" }), true);

const grouppedOperations = computed(() => {
  const getWeekday = (date: number) => formatDate(date, { weekday: "long" });
  const getDate = (date: number) =>
    formatDate(date, { day: "2-digit", month: "long" });

  const groupComparator = (date: number) =>
    `${getDate(date)}, ${getWeekday(date)}`;

  const result = groupBy(operations.value, (op) => groupComparator(op.date));

  return result;
});

function calculateSum(operations: IOperation[]) {
  return operations.reduce((acc, op) => {
    const sign = op.type / 10 > 1 ? -1 : 1;
    return acc + op.sum * sign;
  }, 0);
}

watch(() => currentUser.value?.id, fetchData.execute);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiSuspense, {
    pending: _unref(fetchData).isPending.value,
    failure: _unref(fetchData).isFailure.value,
    success: _unref(fetchData).isSuccess.value,
    variant: "screen",
    "has-retry": ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grouppedOperations), (operations, date) => {
        return (_openBlock(), _createBlock(UiGroup, { key: date }, {
          header: _withCtx(() => [
            _createVNode(UiHeader, { title: date }, {
              right: _withCtx(() => [
                _createVNode(UiCaption, { class: "operation-group__sum" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(calculateSum(operations) >= 0 ? "+ " : "- ") + " " + _toDisplayString(_unref(formatCurrency)(Math.abs(calculateSum(operations)) / 100)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["title"])
          ]),
          default: _withCtx(() => [
            _createVNode(UiCard, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operations, (operation) => {
                  return (_openBlock(), _createBlock(OperationCell, {
                    key: operation.id,
                    operation: operation
                  }, null, 8, ["operation"]))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(UiCaption, {
        level: "3",
        style: {"text-align":"center"}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["pending", "failure", "success"]))
}
}

})